/** @format — Thumbnail URL resolution (avoid slow PDF/file loads in img tags) */

import type { DocumentItem } from "../types";
import { isPhotoUploadType } from "./documentFormatters";

const IMAGE_EXT = /\.(jpe?g|png|gif|webp|bmp|svg|avif)(\?|$)/i;

function isImageUrl(url: string): boolean {
  return IMAGE_EXT.test(url);
}

export function resolveThumbnailSrc(
  document: DocumentItem,
  failed: boolean,
): string | null {
  if (failed) return null;
  if (document.previewUrl) return document.previewUrl;

  const fileUrl = document.fileUrl;
  if (!fileUrl) return null;

  const isPhoto =
    document.kind === "photo" || isPhotoUploadType(document.uploadType);

  if (isPhoto || isImageUrl(fileUrl)) return fileUrl;

  return null;
}
